// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"locationKiosk_wrapper__2mZYN"};